/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssistantGuardrailsEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ASSISTANT_GUARDRAILS_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AssistantGuardrailsEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssistantGuardrailsEnabledSettingParser.decode(input).map(res => new AssistantGuardrailsEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return AssistantGuardrailsEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssistantGuardrailsEnabledSettingParser.encode(data);
    }
    static schema() {
        return AssistantGuardrailsEnabledSettingParser.schema();
    }
}
